import { MediaDataRoomVersion } from "features/mediaDataRoom/models";
import { getMediaDataRoomVersionedValue } from "features/mediaDataRoom/utils";
import { useSafeContext } from "hooks";
import {
  type MediaDataRoomAbContextValue,
  MediaDataRoomContext,
  type MediaDataRoomContextHook,
} from "./models";

export { default as MediaDataRoomAbWrapper } from "./ab/MediaDataRoomAbWrapper";
export { MediaDataRoomContext, MediaDataRoomContextConsumer } from "./models";
export { default as MediaDataRoomV3Wrapper } from "./v3/MediaDataRoomV3Wrapper";

export const useMediaDataRoom = ((version) => {
  const contextValue = useSafeContext(MediaDataRoomContext);
  if (version && contextValue.version !== version) {
    throw new Error(
      `Version mismatch. Expected ${version} but got ${contextValue.version}`
    );
  }
  if (version === MediaDataRoomVersion.ab) {
    return contextValue as MediaDataRoomAbContextValue;
  }
  return contextValue;
}) as MediaDataRoomContextHook;

interface MediaDataRoomVersionedValueHookPayload<T> {
  ab: T;
  v3: T;
}

export const useMediaDataRoomVersionedValue = <T>(
  payload: MediaDataRoomVersionedValueHookPayload<T>
): T => {
  const { version } = useMediaDataRoom();
  return getMediaDataRoomVersionedValue(version, payload);
};
